/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S6_Li3Inputs */

const tr_iade_iptal_s6_li3 = /** @type {(inputs: Iade_Iptal_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deneme Süresi sonrasındaki ilk ücretli satın alma için de 5. maddedeki 3 gün (72 saat) kuralı geçerlidir: ödemenin alınmasından itibaren 3 gün içinde iade talep edilmesi halinde bedelin tamamı iade edilir, sonrasında iade yapılmaz.`)
};

const en_iade_iptal_s6_li3 = /** @type {(inputs: Iade_Iptal_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The 3-day rule (72 hours) in clause 5 also applies to the first paid purchase after the Trial Period: if requested within 3 days from receipt of the payment, the fee is refunded in full; after that no refund is made.`)
};

const de_iade_iptal_s6_li3 = /** @type {(inputs: Iade_Iptal_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für den ersten kostenpflichtigen Kauf nach der Testphase gilt ebenfalls die 3-Tage-Regel (72 Stunden) aus Ziffer 5: Wird die Erstattung innerhalb von 3 Tagen ab Eingang der Zahlung beantragt, wird das Entgelt vollständig erstattet; danach erfolgt keine Erstattung.`)
};

const ru_iade_iptal_s6_li3 = /** @type {(inputs: Iade_Iptal_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`К первой платной покупке после Пробного периода также применяется правило 3 дней (72 часа) из пункта 5: при обращении в течение 3 дней с момента получения платежа сумма возвращается в полном объёме, после этого возврат не производится.`)
};

/**
* | output |
* | --- |
* | "The 3-day rule (72 hours) in clause 5 also applies to the first paid purchase after the Trial Period: if requested within 3 days from receipt of the payment,..." |
*
* @param {Iade_Iptal_S6_Li3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s6_li3 = /** @type {((inputs?: Iade_Iptal_S6_Li3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S6_Li3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s6_li3(inputs)
	if (locale === "de") return de_iade_iptal_s6_li3(inputs)
	if (locale === "ru") return ru_iade_iptal_s6_li3(inputs)
	return tr_iade_iptal_s6_li3(inputs)
});